import {ImportingDataTypes} from "../../types";
import {createInvalidPartSection, PreventionInvalidityCode} from "./shared";

export const preventativeInteraction = {
    datasourceId: ImportingDataTypes.partShortDescription,
    sections: [
        createInvalidPartSection(),
        {
            sectionKey: 'missingShortDescription',
            sectionTitle: 'Missing Product Short Description',
            invalidityCode: PreventionInvalidityCode.MISSING_REQUIRED_FIELDS,
            fields: [
                {
                    key: 'partNumber',
                    label: 'Part Number',
                    type: 'text',
                    extractValue: (o) => typeof o === 'string' ? o : o?.partNumber ?? null,
                    modifyRow: (row, val) => ({...row, partNumber: val})
                },
                {
                    key: 'shortDescription',
                    label: 'Short Description',
                    type: 'input',
                    modifyRow: (row, val) => ({...row, shortDescription: val})
                }
            ]
        }
    ],
};
